export default __webpack_public_path__ + "static/media/card_view_icon_enabled.dd82b414.svg";